import { useGetInstanceInfo } from '@postifoto/api-client';
import type { ReactNode } from 'react';
import { GuestLanguageSelect } from '../components/language-select';
import { Brand } from '../components/ui/brand';

/** Экраны входа без меню: монограмма инстанса над белой карточкой. */
export function AuthLayout({
  title,
  intro,
  children,
}: {
  title: string;
  intro?: ReactNode;
  children: ReactNode;
}) {
  const instance = useGetInstanceInfo();
  return (
    <div className="grid min-h-screen content-start justify-items-center gap-6 px-4 py-6 md:py-12">
      <Brand name={instance.data?.name ?? ''} logoUrl={instance.data?.brand.logoUrl} />
      <section className="grid w-full max-w-form gap-6 rounded-lg border border-hairline bg-canvas p-6 shadow-sm md:p-8">
        <div className="grid gap-2">
          <h1 className="text-display font-semibold text-ink">{title}</h1>
          {intro && <div className="text-base text-body">{intro}</div>}
        </div>
        {children}
      </section>
      <GuestLanguageSelect />
    </div>
  );
}

/** Ссылка-переключатель под формой входа. */
export function AuthLink({
  onClick,
  disabled,
  children,
}: {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      className="justify-self-center text-sm font-medium text-ink underline underline-offset-3 disabled:text-muted disabled:no-underline"
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
